import { jsx } from "react/jsx-runtime";
import {
  CheckboxControlType,
  ColorControlType,
  ComboboxControlType,
  ImageControlType,
  LinkControlType,
  ListControlType,
  NumberControlType,
  RichTextControlType,
  RichTextV2ControlType,
  SelectControlType,
  ShapeControlType,
  SlotControlType,
  StyleControlType,
  StyleV2ControlType,
  TextAreaControlType,
  TextInputControlType,
  TypographyControlType
} from "../../../controls";
import {
  IconRadioGroupControlType
} from "../../../controls/icon-radio-group";
import { RenderHook } from "../components";
import { useCheckboxControlValue } from "./checkbox";
import { useColorValue } from "./color";
import { useComboboxControlValue } from "./combobox";
import { useIconRadioGroupValue } from "./icon-radio-group";
import { useImageControlValue } from "./image";
import { useLinkControlValue } from "./link";
import { ListControlValue } from "./list";
import { useNumber } from "./number";
import { useRichText } from "./rich-text/rich-text";
import { useRichTextV2 } from "./rich-text-v2";
import { useSelectControlValue } from "./select";
import { ShapeControlValue } from "./shape";
import { useSlot } from "./slot";
import { useFormattedStyle } from "./style";
import { StyleV2ControlValue } from "./style-v2";
import { useTextAreaValue } from "./text-area";
import { useTextInputValue } from "./text-input";
import { useTypographyValue } from "./typography";
function ControlValue({
  data,
  definition,
  children,
  control
}) {
  switch (definition.type) {
    case CheckboxControlType:
      return /* @__PURE__ */ jsx(
        RenderHook,
        {
          hook: useCheckboxControlValue,
          parameters: [data, definition],
          children: (value) => children(value)
        },
        definition.type
      );
    case NumberControlType:
      return /* @__PURE__ */ jsx(
        RenderHook,
        {
          hook: useNumber,
          parameters: [data, definition],
          children: (value) => children(value)
        },
        definition.type
      );
    case TextInputControlType:
      return /* @__PURE__ */ jsx(
        RenderHook,
        {
          hook: useTextInputValue,
          parameters: [data, definition],
          children: (value) => children(value)
        },
        definition.type
      );
    case TextAreaControlType:
      return /* @__PURE__ */ jsx(
        RenderHook,
        {
          hook: useTextAreaValue,
          parameters: [data, definition],
          children: (value) => children(value)
        },
        definition.type
      );
    case SelectControlType:
      return /* @__PURE__ */ jsx(
        RenderHook,
        {
          hook: useSelectControlValue,
          parameters: [data, definition],
          children: (value) => children(value)
        },
        definition.type
      );
    case ColorControlType:
      return /* @__PURE__ */ jsx(
        RenderHook,
        {
          hook: useColorValue,
          parameters: [data, definition],
          children: (value) => children(value)
        },
        definition.type
      );
    case IconRadioGroupControlType:
      return /* @__PURE__ */ jsx(
        RenderHook,
        {
          hook: useIconRadioGroupValue,
          parameters: [data, definition],
          children: (value) => children(value)
        },
        definition.type
      );
    case ImageControlType:
      return /* @__PURE__ */ jsx(
        RenderHook,
        {
          hook: useImageControlValue,
          parameters: [data, definition],
          children: (value) => children(value)
        },
        definition.type
      );
    case LinkControlType:
      return /* @__PURE__ */ jsx(
        RenderHook,
        {
          hook: useLinkControlValue,
          parameters: [data, definition],
          children: (value) => children(value)
        },
        definition.type
      );
    case ComboboxControlType:
      return /* @__PURE__ */ jsx(
        RenderHook,
        {
          hook: useComboboxControlValue,
          parameters: [data],
          children: (value) => children(value)
        },
        definition.type
      );
    case ShapeControlType:
      return /* @__PURE__ */ jsx(
        ShapeControlValue,
        {
          definition,
          data,
          control,
          children: (value) => children(value)
        }
      );
    case ListControlType:
      return /* @__PURE__ */ jsx(
        ListControlValue,
        {
          definition,
          data,
          control,
          children: (value) => children(value)
        }
      );
    case StyleV2ControlType:
      return /* @__PURE__ */ jsx(
        StyleV2ControlValue,
        {
          data,
          definition,
          control,
          children: (value) => children(value)
        },
        definition.type
      );
    case SlotControlType:
      return /* @__PURE__ */ jsx(
        RenderHook,
        {
          hook: useSlot,
          parameters: [data, control],
          children: (value) => children(value)
        },
        definition.type
      );
    case RichTextControlType:
      return /* @__PURE__ */ jsx(
        RenderHook,
        {
          hook: useRichText,
          parameters: [data, control],
          children: (value) => children(value)
        },
        definition.type
      );
    case RichTextV2ControlType:
      return /* @__PURE__ */ jsx(
        RenderHook,
        {
          hook: useRichTextV2,
          parameters: [
            data,
            definition,
            control
          ],
          children: (value) => children(value)
        },
        definition.type
      );
    case StyleControlType:
      return /* @__PURE__ */ jsx(
        RenderHook,
        {
          hook: useFormattedStyle,
          parameters: [data, definition, control],
          children: (value) => children(value)
        },
        definition.type
      );
    case TypographyControlType:
      return /* @__PURE__ */ jsx(
        RenderHook,
        {
          hook: useTypographyValue,
          parameters: [data],
          children: (value) => children(value)
        },
        definition.type
      );
    default:
      return children(data);
  }
}
export {
  ControlValue
};
//# sourceMappingURL=control.js.map